import { Action } from '@ngrx/store';

export enum AuthActionTypes {
  LOGIN = '[AUTH] Login',
  LOGIN_SUCCESS = '[Auth] Login Success',
  LOGIN_ERROR = '[Auth] Login ERROR',

  REGISTER = '[AUTH] Register',
  REGISTER_SUCCESS = '[Auth] Register Success',
  REGISTER_ERROR = '[Auth] Register Erorr',

  LOGOUT = '[AUTH] Logout',
  LOGOUT_SUCCESS = '[Auth] Logout Success',
  LOGOUT_ERROR = '[Auth] Logout Error',

  RECOVER_PASSWORD = '[Auth] Recover Password',
  RECOVER_PASSWORD_SUCCESS = '[Auth] Recover Password Success',
  RECOVER_PASSWORD_ERROR = '[Auth] Recover Password Error',

  UPDATE_PASSWORD = '[Auth] Update Password',
  UPDATE_PASSWORD_SUCCESS = '[Auth] Update Password Success',
  UPDATE_PASSWORD_ERROR = '[Auth] Update Password Error',

  UPDATE_PASSWORD_AUTHORISED = '[Auth] Update Password dAuthorised',
  UPDATE_PASSWORD_AUTHORISED_SUCCESS = '[Auth] Update Password dAuthorised Success',
  UPDATE_PASSWORD_AUTHORISED_ERROR = '[Auth] Update Password dAuthorised Error',

  GET_ROLES = '[AUTH] Get Roles',
  GET_ROLES_SUCCESS = '[Auth] Get Roles Success',
  GET_ROLES_ERROR = '[Auth] Get Roles ERROR',

  LOGOUT_CLIENT_SUCCESS = '[Auth] Logout client Success',
}

export class Login implements Action {
  readonly type = AuthActionTypes.LOGIN;
  constructor(public payload: any) {}
}
export class LoginSuccess implements Action {
  readonly type = AuthActionTypes.LOGIN_SUCCESS;
  constructor(public payload: any) {}
}
export class LoginError implements Action {
  readonly type = AuthActionTypes.LOGIN_ERROR;
  constructor(public payload: any) {}
}

export class Register implements Action {
  readonly type = AuthActionTypes.REGISTER;
  constructor(public payload: any) {}
}
export class RegisterSuccess implements Action {
  readonly type = AuthActionTypes.REGISTER_SUCCESS;
  constructor(public payload: any) {}
}
export class RegisterError implements Action {
  readonly type = AuthActionTypes.REGISTER_ERROR;
  constructor(public payload: any) {}
}

export class Logout implements Action {
  readonly type = AuthActionTypes.LOGOUT;
  constructor(public token?: string | null) {}
}
export class LogoutSuccess implements Action {
  readonly type = AuthActionTypes.LOGOUT_SUCCESS;
  constructor(public payload: any) {}
}
export class LogoutClientSuccess implements Action {
  readonly type = AuthActionTypes.LOGOUT_CLIENT_SUCCESS;
}

export class LogoutError implements Action {
  readonly type = AuthActionTypes.LOGOUT_ERROR;
  constructor(public payload: any) {}
}

export class RecoverPassword implements Action {
  readonly type = AuthActionTypes.RECOVER_PASSWORD;
  constructor(public payload: any) {}
}
export class RecoverPasswordSuccess implements Action {
  readonly type = AuthActionTypes.RECOVER_PASSWORD_SUCCESS;
  constructor(public payload: any) {}
}
export class RecoverPasswordError implements Action {
  readonly type = AuthActionTypes.RECOVER_PASSWORD_ERROR;
  constructor(public payload: any) {}
}

export class UpdatePassword implements Action {
  readonly type = AuthActionTypes.UPDATE_PASSWORD;
  constructor(public payload: any) {}
}
export class UpdatePasswordSuccess implements Action {
  readonly type = AuthActionTypes.UPDATE_PASSWORD_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdatePasswordError implements Action {
  readonly type = AuthActionTypes.UPDATE_PASSWORD_ERROR;
  constructor(public payload: any) {}
}

export class UpdatePasswordAuthorised implements Action {
  readonly type = AuthActionTypes.UPDATE_PASSWORD_AUTHORISED;
  constructor(public payload: any) {}
}
export class UpdatePasswordAuthorisedSuccess implements Action {
  readonly type = AuthActionTypes.UPDATE_PASSWORD_AUTHORISED_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdatePasswordAuthorisedError implements Action {
  readonly type = AuthActionTypes.UPDATE_PASSWORD_AUTHORISED_ERROR;
  constructor(public payload: any) {}
}

export class GetRoles implements Action {
  readonly type = AuthActionTypes.GET_ROLES;
}
export class GetRolesSuccess implements Action {
  readonly type = AuthActionTypes.GET_ROLES_SUCCESS;
  constructor(public payload: any) {}
}
export class GetRolesError implements Action {
  readonly type = AuthActionTypes.GET_ROLES_ERROR;
  constructor(public payload: any) {}
}

export type AuthActions =
  | Login
  | LoginSuccess
  | LoginError
  | Register
  | RegisterSuccess
  | RegisterError
  | Logout
  | LogoutSuccess
  | LogoutError
  | RecoverPassword
  | RecoverPasswordSuccess
  | RecoverPasswordError
  | UpdatePassword
  | UpdatePasswordSuccess
  | UpdatePasswordError
  | UpdatePasswordAuthorised
  | UpdatePasswordAuthorisedSuccess
  | UpdatePasswordAuthorisedError
  | GetRoles
  | GetRolesSuccess
  | GetRolesError
  | LogoutClientSuccess;
